$(function () {
  if ($('#switch-learner-modal').length === 0) {
    return;
  }

  const $modal = $('#switch-learner-modal');
  const $initial = $modal.find('.list-group-item.active');
  let $current = $initial;
  const pathForCancel = $modal.data('cancel');

  const setActiveItem = ($item, triggerOnRadio) => {
    const $prev = $current;
    $current = $item;
    $prev.removeClass('active');
    $current.addClass('active');
    // ラジオボタン起因でなければラジオボタンも更新する
    if (!triggerOnRadio) {
      $current.find('input[type="radio"]').prop('checked', true);
    }
    return $current;
  };

  // move to new location
  const setLocation = (href) => {
    if (href && location.href !== href) {
      // 稀に location.href に代入後に 'hidden.bs.modal' イベントが発生することがあるので、リスナーを外す
      $modal.off('hidden.bs.modal');

      // 選択項目を元に戻しておかないとブラウザバックした時に選択項目と活性アイテムが一致しなくなる。
      // 元に戻るのを見せたくないので、モーダルを閉じてから選択項目を元に戻す。
      $modal.modal('hide');
      setActiveItem($initial);

      location.href = href;
    }
  };

  const url = new URL(window.location.href);
  const params = url.searchParams;

  if (params.get('is_show_switch_learner_modal') === 'true') {
    $modal.modal('show');
  }

  document.body
    .querySelector('.learner-head')
    .addEventListener('click', (event) => {
      if (
        getComputedStyle(event.target).getPropertyValue('--trigger-modal') ===
        'true'
      ) {
        $modal.modal('show');
      }
    });

  $modal.find('input[type="radio"]').on('change', (event) => {
    setActiveItem($(event.target).closest('.list-group-item'), true);
  });

  $modal.find('.list-group-item').on('click', (event) => {
    // イベントは.list-group-item要素の子孫上で発生することがあるので、
    // 自身もしくは親を遡って.list-group-itemを探す必要がある
    setActiveItem($(event.target).closest('.list-group-item'));
  });

  $modal.find('.modal-footer .btn-primary').on('click', (_event) => {
    setLocation($current.data('href'));
    $modal.modal('hide');
  });

  $modal.find('.modal-footer .btn-secondary').on('click', (_event) => {
    if (pathForCancel) {
      setLocation(pathForCancel);
    }
    $modal.modal('hide');
  });

  $modal.on('hidden.bs.modal', (_event) => {
    if (pathForCancel) {
      setLocation(pathForCancel);
    }
    setActiveItem($initial);
  });
});
